<template>
  <v-container>
    <getting-data-overlay :is_loading="is_loading"
                          :loading_display_title="$vuetify.lang.t('$vuetify.checklist.getting_data_title')"></getting-data-overlay>
    <v-row v-if="!is_loading && !has_loading_error">
      <v-col cols="12">
        <v-list transition="fade-transition">
          <template v-for="(checklist, index) in checklists">
            <v-list-item class="checklist-item" :key="'checklist_'+index"
                         @click="selectChecklistId(checklist.id, checklist.display_name)"
            >
              <v-list-item-title>{{checklist.display_name}}</v-list-item-title>
              <v-list-item-icon>
                <v-icon>mdi-chevron-right</v-icon>
              </v-list-item-icon>
            </v-list-item>
            <v-divider
                v-if="index + 1 < checklists.length"
                :key="'divider_'+index"
            ></v-divider>
          </template>
        </v-list>
      </v-col>
    </v-row>
    <v-row v-if="has_loading_error">
      <v-col cols="12">
        <v-col cols="12" class="subtitle-1 text-center">
          {{ $vuetify.lang.t('$vuetify.errors.checklistNotLoaded') }}
        </v-col>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GettingDataOverlayComponent
  from "@/components/modules/global/gettingDataOverlayComponent/GettingDataOverlayComponent";
import resourcesApi from "@/api/resources/resourcesApi";

export default {
  name: "ChecklistOverviewComponent",
  data: () => {
    return {
      is_loading: false,
      has_loading_error: false,
      checklists: []
    }
  },
  components: {
    gettingDataOverlay: GettingDataOverlayComponent
  },
  methods: {
    async getChecklistOverview() {
      //window.console.log('LOADING LIST OVERVIEW')
      this.is_loading = true;

      resourcesApi.getChecklistOverview().then((response) => {
        this.is_loading = false;
        this.checklists = response.data
      }).catch((error) => {
        this.is_loading = false;
        this.has_loading_error = true;
        window.console.error(error);
      });
    },
    selectChecklistId($cid, $name){
      //window.console.log('GO AND EMIT!!');
      this.$emit('checklistSelected', {id:$cid, name:$name})
    }
  },
  async mounted(){
    //window.console.log('WHAT THE FUCK BRUH')

      if(this.$auth.isAuthenticated){
        this.getChecklistOverview();
      }

  }
}
</script>

<style scoped>
.checklist-item {
  padding: 20px;
  min-height: 60px;
}
</style>